module.exports = __webpack_public_path__ + "9fe5bc0e46f1534eecd5531f589f958f.jpeg";